import { createContext } from 'react';
import { LeadTabId } from '../../../types/LeadsList';

export type WorkflowStatesContextObj = {
    states: WorkflowStates;
    error?: Response;
};

export type WorkflowStates = {
    [name in LeadTabId]: string[];
};

export const emptyWorkflowStatesContextObj: WorkflowStatesContextObj = {
    states: {
        allLeads: [],
        workflowOpen: [],
        workflowTodos: [],
    },
};

export const WorkflowStatesContext = createContext<WorkflowStatesContextObj>(emptyWorkflowStatesContextObj);
